<div class="content-footer">
    <div class="container-fluid">
        <span>COPYRIGHT © ITEC HANKYU HANSHIN CO.,LTD.</span>
    </div>
</div>